import { createDemoStep } from '@interhyp/platform-demo';
export const PORTAL_OPEN_CREATION = createDemoStep({
    id: 'portal-open-creation',
    description: 'Erstellen Sie schnell und einfach eine neue Baufinanzierung oder einen neuen Ratenkredit mit nur zwei Klicks.',
});
